import { render, staticRenderFns } from "./RichTextarea.vue?vue&type=template&id=6e5c9016&"
import script from "./RichTextarea.vue?vue&type=script&lang=ts&"
export * from "./RichTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports